import React from 'react'
import Styles  from '../../../scss/subscriptions.module.scss'
interface ICardWrapper{
  children:React.ReactNode,
  title:string
}
export function CardWrapper({children,title}:ICardWrapper) {
  return (
    <div className={Styles.CardWrapper}>
      <header>{title}</header>
      {children}
    </div>
  )
}
